/* MiaMia · home nueva: cifras que suben al aparecer y la placa de la guía que se escribe sola. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Cifras: <strong data-mmh-count="55000" data-mmh-suffix="+">55,000+</strong>
  function count(el) {
    var to = Number(el.getAttribute('data-mmh-count')) || 0, suf = el.getAttribute('data-mmh-suffix') || '';
    if (reduce) { el.textContent = to.toLocaleString('en-US') + suf; return; }
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / 1800), e = 1 - Math.pow(1 - t, 3);
      el.textContent = Math.round(to * e).toLocaleString('en-US') + suf;
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var nums = document.querySelectorAll('[data-mmh-count]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); count(e.target); } });
    }, { threshold: .4 });
    nums.forEach(function (n) { io.observe(n); });
  } else nums.forEach(count);

  // Guía: botones de condición + placa que se escribe letra por letra
  document.querySelectorAll('[data-mmh-guide]').forEach(function (root) {
    var data; try { data = JSON.parse(root.querySelector('[data-mmh-guide-data]').textContent); } catch (e) { return; }
    var chips = root.querySelectorAll('[data-mmh-chip]'), box = root.querySelector('[data-mmh-lines]'), cap = root.querySelector('[data-mmh-cap]');
    var sel = 0, k = 0, hold = 0, auto = true, timer = null, visible = false;
    function paint() {
      var ex = data[sel], left = k, html = '', total = ex.lines.join('').length;
      var cursorDone = k >= total;
      ex.lines.forEach(function (l) {
        var shown = l.slice(0, Math.max(0, left)); left -= l.length;
        var typing = !cursorDone && shown.length < l.length;   // primera línea sin terminar = donde va el cursor
        if (typing) cursorDone = true;
        html += '<span' + (typing ? ' class="is-typing"' : '') + '>' + (shown.replace(/&/g, '&amp;').replace(/</g, '&lt;') || ' ') + '</span>';
      });
      box.innerHTML = html; cap.textContent = ex.caption;
      chips.forEach(function (c, i) { c.setAttribute('aria-pressed', i === sel ? 'true' : 'false'); });
    }
    function tick() {
      var total = data[sel].lines.join('').length;
      if (k < total) { k++; paint(); return; }
      if (auto && ++hold > 45) { hold = 0; sel = (sel + 1) % data.length; k = 0; paint(); }
    }
    chips.forEach(function (c, i) {
      c.addEventListener('click', function () { auto = false; hold = 0; sel = i; k = reduce ? 999 : 0; paint(); });
    });
    if (reduce) { k = 999; paint(); return; }
    paint();
    // Solo se anima cuando la sección está en pantalla (ahorra batería y CPU).
    var io2 = new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      if (visible && !timer) timer = setInterval(tick, 55);
      if (!visible && timer) { clearInterval(timer); timer = null; }
    });
    io2.observe(root);
  });
})();

/* 22-oct-2026: entrada suave al hacer scroll, flechas de "más vendidos" y quitar el título repetido de Judge.me. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('mmh-js');
    var sel = '.mmh .mmh-head, .mmh-card, .mmh-fit, .mmh-best__card, .mmh-rev__card, .mmh-cond, .mmh-proof__card, .mmh-faq details, .mmh-rev__head, .mmh-ig__head, .mmh-fam__media, .mmh-fam__text, .mmh-give__img, .mmh-give__text';
    var els = document.querySelectorAll(sel);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) {
      // escalonado dentro de cada grupo de tarjetas
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.transitionDelay = Math.min(sib, 5) * 70 + 'ms';
      el.classList.add('mmh-reveal'); io.observe(el);
    });
  }
  document.querySelectorAll('.mmh-best, .mmh-rev').forEach(function (s) {
    var rail = s.querySelector('[data-mmh-rail]'); if (!rail) return;
    function step(dir) { var c = rail.querySelector('.mmh-best__card, .mmh-rev__card'); rail.scrollBy({ left: dir * ((c ? c.offsetWidth : 280) + 20) * 2, behavior: 'smooth' }); }
    var p = s.querySelector('[data-mmh-prev]'), n = s.querySelector('[data-mmh-next]');
    p && p.addEventListener('click', function () { step(-1); }); n && n.addEventListener('click', function () { step(1); });
  });
  // Judge.me deja su propio H2 "Let customers speak for us" escondido: se quita para no repetir el título.
  function dropJdgmTitle() { document.querySelectorAll('.mmh-rev .jdgm-carousel-title, .mmh-rev .jdgm-carousel__title').forEach(function (h) { h.remove(); }); }
  dropJdgmTitle(); setTimeout(dropJdgmTitle, 2500); setTimeout(dropJdgmTitle, 6000);
})();
